export class Program {
  id = 0;

  name?: string;

  abbr?: string;

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}

export default Program;
